(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("react-api-service-layer", ["React"], factory);
	else if(typeof exports === 'object')
		exports["react-api-service-layer"] = factory(require("react"));
	else
		root["react-api-service-layer"] = factory(root["React"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__156__) => {
return 